import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type SubjectTypeAccessLevelsFetchFailedAction = {
	type: 'SUBJECT_TYPE_ACCESS_LEVELS_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): SubjectTypeAccessLevelsFetchFailedAction => ({
	type: 'SUBJECT_TYPE_ACCESS_LEVELS_FETCH_FAILED',
	payload,
});
